import { createContext } from 'react';

import type { ContextMenuProviderState } from './ContextMenu.types';

const ContextMenuContext = createContext<ContextMenuProviderState | null>(null);

export default ContextMenuContext;
